export enum PATH {
  HOME = "/",
  MEDICAL_DETAILS = "/medical-details",
  NOMINEE_DETAILS = "/nominee-details",
  PROPOSAL_PAGE = "/proposal-page",
  QUOTE_PAGE = "/quote-page",
  TRAVELLER_DETAILS = "/traveller-details",
  TRAVELLER_INFORMATION = "/travleller-information",
  PREVIEW_PAGE = "/preview-page",
  THANK_YOU = "/thank-you",
}
